

import React, { useState, useMemo } from "react";
import Styles from "../../assets/scss/HelpCenterNormalUser/HelpCenterNormalUser.module.scss";
import Pagination from "../../Components/Common/Pagination";
import { FaEye } from "react-icons/fa";
import { useGetEnquiriesQuery } from "../../slices/admin/admin";
import { getUserInfo } from "../../utils/user.util";
import { useNavigate } from "react-router-dom";
import HelpCenterUserForm from "./HelpCenterUserForm";
import PopupWrapper from "../../Components/Common/PopupWrapper";
import { FaArrowRightToBracket } from "react-icons/fa6";

const HelpCenterNormalUser = () => {

  const [showFormPopup, setShowFormPopup] = useState(false);

  const [currentPage, setCurrentPage] = useState(1);
  const [limit, setLimit] = useState(10);

  const navigate = useNavigate();
  const localUser = getUserInfo();
  const userId = localUser?._id;

  const {
    data: enquiryRes,
    isLoading: enquiryLoading,
    refetch,
  } = useGetEnquiriesQuery(
    {
      userId,
      offset: currentPage,
      limit: limit,
    },
    { skip: !userId }
  );

  const ticketData = enquiryRes?.data || [];
  const totalCount = enquiryRes?.total || 0;
  const totalPages = Math.ceil(totalCount / limit);

  const issueMap = useMemo(() => {
    const map = {};
    ticketData.forEach((item) => {
      item.queries?.forEach((q) => {
        map[q] = q;
      });
    });
    return map;
  }, [ticketData]);

  const handleView = (enquiryId) => {
    navigate("/dashboard/HelpCenterUserView", {
      state: { enquiryId },
    });
  };

  return (
    <div className={Styles.parent}>
      <div className={Styles.box}>

        {/* ================= HEADER ================= */}
        <div className={Styles.headerRow}>
          <h1 className={Styles.heading}>Help Center</h1>

          <button
            className={Styles.addBtn}
            onClick={() => setShowFormPopup(true)}
          >
            + Create Ticket
          </button>
        </div>
        {/* ================= HELP INFO SECTION ================= */}
        <div className={Styles.helpInfoSection}>
          <h3 className={Styles.infoHeading}>How to make use of our Help Center!</h3>
          <p className={Styles.infoText}>We're here to assist you in any way possible. If you have any questions or issues, please don't hesitate to reach out to our support team.</p>
          <p className={Styles.infoText}>
            <strong>Call us @ <span className={Styles.greenHighlight}>6385161611</span> / Mail us @ <span className={Styles.greenHighlight}>Support@cropwork.in</span></strong>
          </p>
          <p className={Styles.infoText}>We are available Monday to Friday from 10:00 am to 9:00 pm IST.</p>
          <p className={Styles.infoText}>
            Simply click on the <strong>'Create Ticket'</strong> button located on the Top Right Menu, and provide the details.
          </p>
          <p className={Styles.infoText}>
            We'll do our very best to respond to all your questions within 8-12 hours, although during exceptional circumstances, it might take us a bit longer.
          </p>
          <p className={Styles.infoText}>
            We are committed, we appreciate your patience and understanding as we strive to provide the best support possible.
          </p>
        </div>
        {/* ================= POPUP ================= */}
        {showFormPopup && (
          <PopupWrapper onClose={() => setShowFormPopup(false)}>
            <HelpCenterUserForm
              onSuccess={() => {
                setShowFormPopup(false);
                refetch();
              }}
              onClose={() => setShowFormPopup(false)}
            />
          </PopupWrapper>
        )}

        {/* ================= TABLE ================= */}
        <div className={Styles.tableWrapper}>
          <table className={Styles.table}>
            <thead>
              <tr>
                <th>Ticket No</th>
                <th>Issue Name</th>
                <th>Description</th>
                <th>Mode of Contact</th>
                <th>Status</th>
                <th>Created At</th>
                <th>Action</th>
              </tr>
            </thead>

            <tbody>
              {enquiryLoading && (
                <tr>
                  <td colSpan={7} style={{ textAlign: "center", padding: "20px" }}>
                    Loading...
                  </td>
                </tr>
              )}

              {!enquiryLoading && ticketData.length === 0 && (
                <tr>
                  <td colSpan={7} style={{ textAlign: "center", padding: "20px" }}>
                    No data found
                  </td>
                </tr>
              )}

              {!enquiryLoading &&
                ticketData.map((item) => (
                  <tr key={item._id}>
                    <td>{item.enquiryId}</td>

                    <td>
                      {item.queries?.map((q) => issueMap[q] || q).join(", ")}
                    </td>

                    <td>{item.comments || "-"}</td>

                    <td>{item.modeOfContact || "-"}</td>

                    <td>
                      <span
                        className={
                          item.status === "completed"
                            ? Styles.statusCompleted
                            : item.status === "inprogress"
                              ? Styles.statusInProgress
                              : Styles.statusPending
                        }
                      >
                        {item.status}
                      </span>
                    </td>

                    <td>
                      {new Date(item.createdAt).toLocaleString("en-IN")}
                    </td>

                    <td>
                      <FaArrowRightToBracket
                        className={Styles.deleteIcon}
                        style={{ cursor: "pointer" }}
                        onClick={() => handleView(item._id)}
                      />
                    </td>
                  </tr>
                ))}
            </tbody>
          </table>
        </div>

        {/* ================= PAGINATION ================= */}
        {/* ================= PAGINATION ================= */}
        <div className={Styles.paginationContainer}>
          <Pagination
            currentPage={currentPage}
            totalPages={totalPages}
            onPageChange={setCurrentPage}
          />

          <select
            value={limit}
            className={Styles.inputsbtn}
            onChange={(e) => {
              setLimit(Number(e.target.value));
              setCurrentPage(1);
            }}
          >
            <option value={10}>10 rows</option>
            <option value={25}>25 rows</option>
            <option value={50}>50 rows</option>
          </select>
        </div>
      </div>


    </div>
  );
};

export default HelpCenterNormalUser;




